import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LangSwitcher } from "@/components/site/Header";

export const BookShell = ({ children }) => (
  <div className="min-h-screen bg-[#f6f2ec] text-[#1d2b31]">
    <header className="bg-[#15262d] text-white">
      <div className="max-w-5xl mx-auto px-6 py-5 flex items-center justify-between gap-4">
        <Link to="/" data-testid="book-back-home" className="flex items-center gap-2 text-sm text-white/70 hover:text-white">
          <ArrowLeft size={16} /> <span className="hidden sm:inline">tribebeachkos.gr</span>
        </Link>
        <img src="/logo-sand.png" alt="Tribe Beach Lounge logo" className="h-7" />
        <LangSwitcher />
      </div>
    </header>
    <main className="max-w-5xl mx-auto px-6 py-12">{children}</main>
  </div>
);
